import React from "react";
import styles from "./PermissionMessage.module.css";

const PermissionMessage = () => {
  return (
    <div className={styles.container} role="alert" aria-live="polite">
      You are not authorized to view this page
    </div>
  );
};

export default PermissionMessage;
